import React, { useState, useEffect } from "react";
import MeanOfTransport from "./MeanOfTransport";
import "./Chain.css";

function Chain({
  chainOrder,
  onFinancialCostUpdate,
  onTimeValueUpdate,
  onEnvCostUpdate,
}) {
  const [value, setValue] = useState("");
  const [showTransport, setShowTransport] = useState(false);
  const [commisionValues, setCommisionValues] = useState([]);
  const [financialCost, setFinancialCost] = useState(0);
  const [timeValues, setTimeValues] = useState([]);
  const [totalTimeValue, setTotalTimeValue] = useState(0);
  const [remove, setRemove] = useState(false);
  const [envCosts, setEnvCosts] = useState([]);
  const [totalEnvCost, setTotalEnvCost] = useState(0);

  useEffect(() => {
    onEnvCostUpdate(chainOrder, totalEnvCost);
  }, [totalEnvCost]);

  useEffect(() => {
    const sumOfEnvCosts = envCosts.reduce((total, value) => total + value, 0);
    setTotalEnvCost(sumOfEnvCosts);
    console.log(envCosts);
    // Perform any actions related to totalEnvCost update here
  }, [envCosts]);

  const handleEnvCostChange = (newEnvCost) => {
    setEnvCosts((prevEnvCosts) => {
      const updatedEnvCosts = [...prevEnvCosts];
      updatedEnvCosts.push(newEnvCost);
      return updatedEnvCosts;
    });
  };

  useEffect(() => {
    const sumOfTimeValues = timeValues.reduce(
      (total, value) => total + parseInt(value, 10),
      0
    );
    setTotalTimeValue(sumOfTimeValues);
    onTimeValueUpdate(chainOrder, sumOfTimeValues); // Pass the chain order and total time value to the parent component
  }, [timeValues]);

  const handleTimeChange = (orderNumber, newTime) => {
    setTimeValues((prevTimeValues) => {
      const updatedTimeValues = [...prevTimeValues];
      updatedTimeValues[orderNumber - 1] = newTime;

      const sumOfTimeValues = updatedTimeValues.reduce(
        (total, value) => total + parseInt(value, 10),
        0
      );
      setTotalTimeValue(sumOfTimeValues);

      return updatedTimeValues;
    });
  };

  useEffect(() => {
    const updatedFinancialCost = commisionValues.reduce(
      (total, value) => total + parseFloat(value, 10),
      0
    );
    setFinancialCost(updatedFinancialCost);
    onFinancialCostUpdate(chainOrder, updatedFinancialCost); // Pass the chain order and financial cost to the parent component
  }, [commisionValues]);

  const handleCommisionChange = (orderNumber, newCommision) => {
    setCommisionValues((prevCommisionValues) => {
      const updatedCommisionValues = [...prevCommisionValues];
      updatedCommisionValues[orderNumber - 1] = newCommision;

      const updatedFinancialCost = updatedCommisionValues.reduce(
        (total, value) => total + parseInt(value, 10),
        0
      );
      setFinancialCost(updatedFinancialCost);

      return updatedCommisionValues;
    });
  };

  const handleChange = (event) => {
    const inputValue = event.target.value;

    // Only allow positive numeric values
    if (/^\d*$/.test(inputValue)) {
      setValue(inputValue);
    }
  };

  const handleButtonClick = () => {
    setShowTransport(true);
    setRemove(true);
  };

  const renderMeanOfTransport = () => {
    if (!showTransport) {
      return null;
    }

    if (value === "") {
      return <div>Please enter a positive integer</div>;
    }

    const count = parseInt(value, 10);

    if (isNaN(count) || count <= 0) {
      return <div>Please enter a positive integer</div>;
    }

    const meanOfTransportComponents = [];
    for (let i = 0; i < count; i++) {
      meanOfTransportComponents.push(
        <MeanOfTransport
          key={i}
          orderNumber={i + 1}
          onCommisionChange={handleCommisionChange}
          onTimeChange={handleTimeChange}
          onEnvCostChange={handleEnvCostChange}
        />
      );
    }

    return meanOfTransportComponents;
  };

  return (
    <div className="chain">
      <h1 style={{ marginLeft: "40px" }}>Αλυσίδα {chainOrder}</h1>
      {!remove && (
        <>
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="Εισάγετε τον αριθμό διαφορετικών μέσων που χρησιμοποιείτε για την αλυσίδα μετακίνησής σας."
            style={{
              width: "730px",
              height: "40px",
              marginTop: "5px",
              fontSize: "16px",
            }}
          />
          <button onClick={handleButtonClick} style={{ marginLeft: "10px" }}>
            Εισαγωγή
          </button>
        </>
      )}
      {renderMeanOfTransport()}
    </div>
  );
}

export default Chain;
